import NavbarItems from "./NavbarItems";


export default function NavbarFooter() {
  return (
    <div className="container-fluid sub-navbar navbar navbar-expand-md navbar-dark">
      <div className="container">
        <NavbarItems type="sub"/>
      </div>
    </div>
  );
}
